import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postLogService } from 'api';

// Then, handle actions in your reducers:
const logServiceSlice = createSlice({
  name: 'logService',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    logServicePostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
      state.error = false;
    },
    logServicePostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = false;
    },
    logServicePostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    logServiceFormReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  logServicePostStart,
  logServicePostSuccess,
  logServicePostFail,
  logServiceFormReset,
} = logServiceSlice.actions;

// The reducer
export const logServiceReducer = logServiceSlice.reducer;

// Asynchronous thunk action
export const logServicePost = (formData) => (dispatch) => {
  dispatch(logServicePostStart());

  postLogService(formData)
    .then((payload) => {
      dispatch(logServicePostSuccess(payload));
    })
    .catch((error) => {
      dispatch(logServicePostFail(error));
    });
};
